window.dbs = window.dbs || {}
dbs.google = dbs.google || {}

dbs.google.placesAutocompleteService = function (google) {
  const self = this

  // Get API key from Google Maps script tag
  const getApiKey = () => {
    // Extract from Google Maps script tag
    const scripts = document.querySelectorAll('script[src*="maps.googleapis.com"]');
    for (const script of scripts) {
      const match = script.src.match(/key=([^&]+)/);
      if (match) {
        return match[1];
      }
    }
    
    console.error('Google Maps API key not found in script tag. Please ensure Google Maps script is loaded.');
    return null;
  };

  /**
   * Retrieves place autocomplete predictions based on the supplied autocomplete request.
   * Now uses the new Places API (New) endpoint while maintaining the same interface.
   * See: https://developers.google.com/maps/documentation/places/web-service/autocomplete
   * @function
   * @param {object} request - Legacy AutocompletionRequest format that will be converted to new API format
   * @param {function} callback - callback: function(Array<AutocompletePrediction> optional, PlacesServiceStatus): void
   */
  self.getPlacePredictions = function (request, callback) {
    const apiKey = getApiKey();
    if (!apiKey) {
      callback(null, 'REQUEST_DENIED');
      return;
    }

    // Convert legacy request format to new API format
    const newApiRequest = {
      input: request.input || '',
    };

    // Add session token if provided
    if (request.sessionToken) {
      // For new API, session tokens are generated as UUID strings, not objects
      if (typeof request.sessionToken === 'object' && request.sessionToken.toString) {
        newApiRequest.sessionToken = request.sessionToken.toString();
      } else {
        newApiRequest.sessionToken = request.sessionToken;
      }
    }

    // Add location restrictions if provided
    if (request.componentRestrictions?.country) {
      newApiRequest.regionCode = request.componentRestrictions.country.toUpperCase();
    }

    // Add location bias if bounds are provided
    if (request.bounds) {
      newApiRequest.locationBias = {
        rectangle: {
          low: {
            latitude: request.bounds.getSouthWest().lat(),
            longitude: request.bounds.getSouthWest().lng()
          },
          high: {
            latitude: request.bounds.getNorthEast().lat(),
            longitude: request.bounds.getNorthEast().lng()
          }
        }
      };
    }

    // Add types if provided (convert legacy types to new format)
    if (request.types && request.types.length > 0) {
      newApiRequest.includedPrimaryTypes = request.types;
    }

    // Make the REST API call to new Places API
    fetch('https://places.googleapis.com/v1/places:autocomplete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': 'suggestions.placePrediction.place,suggestions.placePrediction.text,suggestions.placePrediction.placeId'
      },
      body: JSON.stringify(newApiRequest)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    })
    .then(data => {
      // Convert new API response format to legacy format for backward compatibility
      const legacyPredictions = (data.suggestions || [])
        .filter(suggestion => suggestion.placePrediction)
        .map(suggestion => {
          const prediction = suggestion.placePrediction;
          return {
            description: prediction.text?.text || '',
            matched_substrings: [], // New API doesn't provide this in the same format
            place_id: prediction.placeId || '',
            reference: prediction.placeId || '', // For legacy compatibility
            structured_formatting: {
              main_text: prediction.text?.text || '',
              main_text_matched_substrings: [],
              secondary_text: ''
            },
            terms: [], // New API doesn't provide terms in legacy format
            types: [] // Would need additional API call to get types
          };
        });

      // Simulate legacy PlacesServiceStatus.OK
      callback(legacyPredictions, 'OK');
    })
    .catch(error => {
      console.error('Places Autocomplete API error:', error);
      
      // Map different error types to legacy status codes
      let status = 'UNKNOWN_ERROR';
      if (error.message.includes('403')) {
        status = 'REQUEST_DENIED';
      } else if (error.message.includes('400')) {
        status = 'INVALID_REQUEST';
      } else if (error.message.includes('429')) {
        status = 'OVER_QUERY_LIMIT';
      }
      
      callback(null, status);
    });
  }
}
